import { fromEmpty } from 'maybeasy';
import { observer } from 'mobx-react';
import { T } from '../../../../../../../Translations';
import { ShareableLink } from '../../Types';
import LinkRow from './LinkRow';

interface Props {
  programFamilyShareUrls: ShareableLink[];
}

function TableBody({ programFamilyShareUrls }: Props) {
  return fromEmpty(programFamilyShareUrls)
    .map((programFamilyShareUrls) => <LinkRow programFamilyShareUrls={programFamilyShareUrls} />)
    .getOrElse(() => (
      <tr className="bg-muted text-center">
        <td colSpan={5} className="p-36 text-muted-foreground">
          <T kind="No Shareable Links to display" />
        </td>
      </tr>
    ));
}

export default observer(TableBody);
